module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DC79_1SD_HUN.572d4760.jpg";